var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M8.00079 2C5.39125 2 3.27579 4.07997 3.27579 6.64574C3.27579 6.67361 3.27604 6.70143 3.27654 6.72918C2.11163 7.02363 1.25079 8.06319 1.25079 9.30044C1.25079 10.2831 1.79376 11.141 2.60079 11.6H13C13.8197 10.9946 14.7508 9.72242 14.7508 8.63677C14.7508 7.22534 13.8546 6.01973 12.5912 5.54005C12.0866 3.50809 10.2228 2 8.00079 2Z",
    fill: "#6C7689"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60079 11.6C1.79376 11.141 1.25079 10.2831 1.25079 9.30044C1.25079 8.06319 2.11163 7.02363 3.27654 6.72918C3.27604 6.70143 3.27579 6.67361 3.27579 6.64574C3.27579 4.07997 5.39125 2 8.00079 2C10.2228 2 12.0866 3.50809 12.5912 5.54005C13.8546 6.01973 14.7508 7.22534 14.7508 8.63677C14.7508 9.72242 14.2205 10.6863 13.4008 11.2917M8.00079 14.5V9.25M8.00079 9.25L10.4008 11.65M8.00079 9.25L5.50079 11.75",
    stroke: "#6C7689",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.4574e298acd2290f4458a48296771c54.svg";
export { ForwardRef as ReactComponent };